import React from "react";

const Header = ({ onClick, props }) => {
    return (
        <React.Fragment>
            <div className="chatbot-chatbox-header">
                {props.title}
                <span
                    className="chatbot-chatbox-header-close-toggle"
                    onClick={onClick}
                >
                    <i className="fas fa-times"></i>
                </span>
            </div>
        </React.Fragment>
    );
};

export default Header;
